import i18n from './../../../../shared/i18n';
import BaseModel from "../../../../core/components/input-widget/BaseModel";
import moment from "moment";
import {SYSTEM_DATE_FORMAT, SYSTEM_TIME_FORMAT} from "@/core/services/formatter.service";

export default class CampaignModel extends BaseModel {
  uuid = null;
  title = null;
  scheduled_at = null;
  schedule_date = null;
  schedule_time = null;
  subject = null;
  text = null;
  from_name = null;
  reply_to = null;
  audience_uuid = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (this.uuid && this.scheduled_at) {
      const scheduleData = this.scheduled_at;
      this.schedule_date = moment(scheduleData).format(SYSTEM_DATE_FORMAT);
      this.schedule_time = moment(scheduleData).format(SYSTEM_TIME_FORMAT);
    }
  }

  toJSON() {
    let data = super.toJSON();

    if (this.schedule_date) {
      let currentTzStartDate = moment(`${data.schedule_date} ${data.schedule_time || '12:00:00'}`);
      let utcStartDate = moment(currentTzStartDate.toISOString()).utc();
      data.scheduled_at = `${utcStartDate.format(SYSTEM_DATE_FORMAT)} ${utcStartDate.format(SYSTEM_TIME_FORMAT)}`;
    }

    return data;
  }

  rules = {};

  attributeHints = {};

  attributeLabels = {
    title: i18n.t('Title'),
    subject: i18n.t('Subject'),
    schedule_date: i18n.t('Schedule Date'),
    schedule_time: i18n.t('Schedule Time'),
    text: i18n.t('Body'),
    from_name: i18n.t('From Name'),
    reply_to: i18n.t('Reply To'),
  };
}
